import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import globalContext from '../../config/context';
import 'leaflet/dist/leaflet.css';
import './Maps.css';
import L from 'leaflet';

import {LayersControl, Map, Marker, Popup, TileLayer, WMSTileLayer, GeoJSON, ZoomControl, ScaleControl} from 'react-leaflet';
import {BingLayer} from 'react-leaflet-bing-v2';
import SearchMobile from './SearchBox/SearchMobile';
import Loading from '../../component/Loading';
import DrawersMobile from './Drawers/DrawersMobile';
import {Drawer} from '@material-ui/core';
import Center from './Center/CenterMobile';

const useStyles = makeStyles((theme) => ({
  body: {},
  map: {},
  center: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  legend: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  search: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  loading: {
    // position: 'absolute',
    // width: '100%',
    // top: 0,
    // display:'none',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    flexDirection: 'unset',
  },
}));

const MapsMobile = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [
    {pencarian, checkedPbb, checkedBphtb, checkedPendataan, centroidLatitude, centroidLongitude, zoomKelurahan, zoomBlok, zoomPersil},
    {
      setPencarian,
      setCheckedPbb,
      setCheckedBphtb,
      setCheckedPendataan,
      setCentroidLatitude,
      setCentroidLongitude,
      setZoomKelurahan,
      setZoomBlok,
      setZoomPersil,
    },
  ] = useAppContext();
  const {
    mapRef,
    baseLayerChange,
    zoomEnd,
    dragEnd,
    kelurahanRefGeoJson,
    getKelurahan,
    blokRefGeoJson,
    getBlok,
    persilRefGeoJson,
    getPersil,
    zntRefGeoJson,
    getZnt,
    markerPbbRefGeoJson,
    getMarkerPbb,
    markerBphtbRefGeoJson,
    getMarkerBphtb,
    markerHotelRefGeoJson,
    getMarkerHotel,
    markerRestoranRefGeoJson,
    getMarkerRestoran,
    markerHiburanRefGeoJson,
    getMarkerHiburan,
    markerReklameRefGeoJson,
    getMarkerReklame,
    markerPpjRefGeoJson,
    getMarkerPpj,
    markerParkirRefGeoJson,
    getMarkerParkir,
    markerPatRefGeoJson,
    getMarkerPat,
    markerWaletRefGeoJson,
    getMarkerWalet,
    markerMblbRefGeoJson,
    getMarkerMblb,
    markerPendataanRefGeoJson,
    getMarkerPendataan,
    inputNop,
    setInputNop,
    facebookProgress,
    clearIcon,
    handleKeyPress,
    onClear,
    onSearchNop,
    checked,
    handleDetails,
    searchNop,
    searchSppt,
    piutangLoading,
    tahunSPPT,
    handleTahunSPPT,
    itemTahunSPPT,
    detailNop,
    detailSppt,
    images,
    streetView,
  } = props;

  //drawer
  const [drawer, setDrawer] = React.useState(false);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const cariCoordinat = [latitude, longitude];

  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  const state = {
    lat: centroidLatitude,
    lng: centroidLongitude,
    zoom: zoomKelurahan,
  };

  const {BaseLayer} = LayersControl;
  const bing_key = 'AuhiCJHlGzhg93IqUH_oCpl_-ZUrIE6SPftlyGYUvr9Amx5nzA-WqGcPquyFZl4L';
  const position = [state.lat, state.lng];

  return (
    <div className={classes.body}>
      <div className={classes.map}>
        <Map
          ref={mapRef}
          className="map"
          center={position}
          zoom={state.zoom}
          zoomControl={false}
          onBaseLayerChange={baseLayerChange}
          onZoomEnd={zoomEnd}
          onDragEnd={dragEnd}>
          {checked ? null : (
            <LayersControl position="bottomright">
              <BaseLayer checked name="Open Street Maps">
                <TileLayer
                  attribution='<a href="http://citracom.co.id/" target="blank">CIP</a> &copy; <a href="https://www.openstreetmap.org/" target="blank">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </BaseLayer>
              <BaseLayer name="Google Maps">
                <TileLayer
                  attribution='<a href="http://citracom.co.id/" target="blank">CIP</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                  url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                />
              </BaseLayer>
              <BaseLayer name="Bing Maps">
                <BingLayer bingkey={bing_key} />
              </BaseLayer>
              <BaseLayer name="Google Satelite">
                <TileLayer
                  attribution='<a href="http://citracom.co.id/" target="blank">CIP</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                  url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                />
              </BaseLayer>
            </LayersControl>
          )}
          {checked ? null : <ZoomControl position="bottomright" />}
          {checked ? null : <ScaleControl />}

          {latitude ? (
            <Marker position={cariCoordinat}>
              <Popup>
                Latitude : {latitude} <br /> Longitude : {longitude}
              </Popup>
            </Marker>
          ) : null}

          <GeoJSON ref={markerPendataanRefGeoJson} />
          <GeoJSON ref={kelurahanRefGeoJson} />

          {pencarian.state !== 'znt' ? (
            <div>
              <GeoJSON ref={blokRefGeoJson} />
              <GeoJSON ref={persilRefGeoJson} />
            </div>
          ) : (
            <div>
              <GeoJSON ref={zntRefGeoJson} />
            </div>
          )}

          <GeoJSON ref={markerPbbRefGeoJson} />
          <GeoJSON ref={markerBphtbRefGeoJson} />
          <GeoJSON ref={markerHotelRefGeoJson} />
          <GeoJSON ref={markerRestoranRefGeoJson} />
          <GeoJSON ref={markerHiburanRefGeoJson} />
          <GeoJSON ref={markerReklameRefGeoJson} />
          <GeoJSON ref={markerPpjRefGeoJson} />
          <GeoJSON ref={markerParkirRefGeoJson} />
          <GeoJSON ref={markerPatRefGeoJson} />
          <GeoJSON ref={markerWaletRefGeoJson} />
          <GeoJSON ref={markerMblbRefGeoJson} />
        </Map>
      </div>

      <div className={classes.center + ' leaflet-control'}>
        <Center mapRef={mapRef} state={state} />
      </div>

      <div className={classes.search + ' leaflet-control'}>
        <SearchMobile
          setDrawer={setDrawer}
          inputNop={inputNop}
          setInputNop={setInputNop}
          facebookProgress={facebookProgress}
          clearIcon={clearIcon}
          handleKeyPress={handleKeyPress}
          onClear={onClear}
          onSearchNop={onSearchNop}
          checked={checked}
          handleDetails={handleDetails}
          searchNop={searchNop}
          searchSppt={searchSppt}
          piutangLoading={piutangLoading}
          tahunSPPT={tahunSPPT}
          handleTahunSPPT={handleTahunSPPT}
          itemTahunSPPT={itemTahunSPPT}
          detailNop={detailNop}
          detailSppt={detailSppt}
          images={images}
          streetView={streetView}
        />
      </div>

      <div>
        <Drawer
          classes={{
            paper: classes.drawer,
          }}
          anchor={'left'}
          open={drawer}
          onClose={() => setDrawer(false)}>
          <DrawersMobile
            drawer={drawer}
            setDrawer={setDrawer}
            mapRef={mapRef}
            getKelurahan={getKelurahan}
            getBlok={getBlok}
            getPersil={getPersil}
            getZnt={getZnt}
            markerPbbRefGeoJson={markerPbbRefGeoJson}
            getMarkerPbb={getMarkerPbb}
            markerBphtbRefGeoJson={markerBphtbRefGeoJson}
            getMarkerBphtb={getMarkerBphtb}
            markerHotelRefGeoJson={markerHotelRefGeoJson}
            getMarkerHotel={getMarkerHotel}
            markerRestoranRefGeoJson={markerRestoranRefGeoJson}
            getMarkerRestoran={getMarkerRestoran}
            markerHiburanRefGeoJson={markerHiburanRefGeoJson}
            getMarkerHiburan={getMarkerHiburan}
            markerReklameRefGeoJson={markerReklameRefGeoJson}
            getMarkerReklame={getMarkerReklame}
            markerPpjRefGeoJson={markerPpjRefGeoJson}
            getMarkerPpj={getMarkerPpj}
            markerParkirRefGeoJson={markerParkirRefGeoJson}
            getMarkerParkir={getMarkerParkir}
            markerPatRefGeoJson={markerPatRefGeoJson}
            getMarkerPat={getMarkerPat}
            markerWaletRefGeoJson={markerWaletRefGeoJson}
            getMarkerWalet={getMarkerWalet}
            markerMblbRefGeoJson={markerMblbRefGeoJson}
            getMarkerMblb={getMarkerMblb}
            markerPendataanRefGeoJson={markerPendataanRefGeoJson}
            getMarkerPendataan={getMarkerPendataan}
            setInputNop={setInputNop}
            latitude={latitude}
            setLatitude={setLatitude}
            longitude={longitude}
            setLongitude={setLongitude}
          />
        </Drawer>
      </div>

      <div className={classes.loading + ' leaflet-control'}>
        <Loading />
      </div>
    </div>
  );
};

export default MapsMobile;
